import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { environment } from "../../environments/environment";
import { Observable, Subject } from "rxjs";
import { RxFormGroup } from "@rxweb/reactive-form-validators";

@Injectable({
    providedIn: "root",
})
export class CompanyClientService {
    baseUrl = `${environment.apis.base}/company-clients`;

    constructor(private readonly http: HttpClient) {}

    // company-clients.service.ts
    datatable(page?: number, options: any = {}): Observable<any> {
        let httpParams = new HttpParams();

        if (typeof page === "number") {
            httpParams = httpParams.append("page", page);
        }

        if ("key" in options && options.key.trim() !== "") {
            httpParams = httpParams.append("search", options.key);
        }

        // Aquí debes agregar esto para enviar los filtros correctamente:
        if ("client_id" in options && options.client_id) {
            httpParams = httpParams.append("client_id", options.client_id);
        }

        return this.http.get<any>(this.baseUrl, { params: httpParams });
    }

    createOrUpdate(data: RxFormGroup, id?: number): Observable<Object> {
        let url = this.baseUrl;

        if (id) {
            url += `/${id}`;
            // Si estamos actualizando, enviamos JSON plano, NO FormData
            return this.http.put<any>(url, data.getRawValue());
        }

        // Si estamos creando, sí usamos FormData
        return this.http.post<any>(url, data.toFormData());
    }

    delete(id: number): Observable<Object> {
        const url = `${this.baseUrl}/${id}`;

        return this.http.delete<any>(url);
    }

    getMediasByClient(id: number): Promise<any> {
        let url = `${environment.apis.base}/clients/${id}/medias`;

        return this.http.get<any>(url).toPromise();
    }
    
    getMediasByCompany(id: number): Promise<any> {
        let url = `${environment.apis.base}/company-clients/mediaItems/${id}`;

        return this.http.get<any>(url).toPromise();
    }

    getCompaniesByClient(id: number): Promise<any> {
        let url = `${environment.apis.base}/company-clients/list?client_id=${id}`;

        return this.http.get<any>(url).toPromise();
    }

    getActives(): Promise<any> {
        let url = `${this.baseUrl}/active`;

        return this.http.get<any>(url).toPromise();
    }
}
